import type { CarrierManualUnits } from '@/lib/api/carrier-shipment-api'

export interface CarrierQuoteContext {
    shippingAddress: string
    shippingProvince?: string | null
    shippingProvinceCode?: string | null
    shippingWard?: string | null
    shippingWardCode?: string | null
    totalAmount: number
    paidAmount: number
    collectCod?: boolean | null
}

function canonicalText(value?: string | null): string {
    return (value ?? '')
        .normalize('NFC')
        .trim()
        .replace(/\s+/g, ' ')
        .toLocaleLowerCase('vi')
}

export function carrierQuoteFingerprint(
    context: CarrierQuoteContext,
    weightGram: number,
    units?: CarrierManualUnits,
    legacyWardId?: number,
): string {
    return JSON.stringify([
        canonicalText(context.shippingAddress),
        canonicalText(context.shippingProvince),
        canonicalText(context.shippingProvinceCode),
        canonicalText(context.shippingWard),
        canonicalText(context.shippingWardCode),
        Number.isFinite(context.totalAmount) ? context.totalAmount : null,
        Number.isFinite(context.paidAmount) ? context.paidAmount : null,
        context.collectCod === true,
        Number.isInteger(weightGram) ? weightGram : null,
        units?.vtp_province_id ?? null,
        units?.vtp_ward_id ?? null,
        legacyWardId ?? null,
    ])
}
